import { handleActions } from "redux-actions";

import { defaultState } from "../configureStore";

const dealModalReducer = handleActions(
  {
    DEAL_MODAL: {
      ASSETS_SELECT: ({ dealModal }, action) => ({
        dealModal: { ...dealModal, selectedAssets: [...action.payload.assets] },
      }),

      CLOSE: () => ({
        dealModal: { ...defaultState.dealModal },
        isDealModalOpen: false,
      }),

      OPEN: (_state, { meta: { parent }, payload: { deal, mail } }) => ({
        isDealModalOpen: true,
        dealModal: {
          ...defaultState.dealModal,
          deal,
          mail,
          parent,
        },
      }),

      SHARE_MODAL_CLOSE: ({ dealModal }) => ({
        dealModal: { ...dealModal, isShareModalOpen: false },
      }),

      SHARE_MODAL_OPEN: ({ dealModal }) => ({
        dealModal: { ...dealModal, isShareModalOpen: true },
      }),

      SHARE_STATUS_SELECT: ({ dealModal }, action) => ({
        dealModal: {
          ...dealModal,
          shareStatus: action.payload.shareStatus,
          sharedBrokers: action.payload.sharedBrokers,
        },
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default dealModalReducer;
